module.exports = __webpack_public_path__ + "images/right-e3d833ef92170928a091026665cd7b8a.png";